import { render, staticRenderFns } from "./ImagesWidget.vue?vue&type=template&id=0a5b6b7f&scoped=true&"
import script from "./ImagesWidget.vue?vue&type=script&lang=js&"
export * from "./ImagesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5b6b7f",
  null
  
)

export default component.exports